import { render, staticRenderFns } from "./EditModuleDlg.vue?vue&type=template&id=834256ae&scoped=true&"
import script from "./EditModuleDlg.vue?vue&type=script&lang=ts&"
export * from "./EditModuleDlg.vue?vue&type=script&lang=ts&"
import style0 from "./EditModuleDlg.vue?vue&type=style&index=0&id=834256ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834256ae",
  null
  
)

export default component.exports